import React, {useContext} from "react";
import "./YouTube.scss";
import {youtubeSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function YouTube() {
  const {isDark} = useContext(StyleContext);
  
  if (!youtubeSection)
    console.error("youtubeSection object for YouTube section is missing");
  if (!youtubeSection.display) {
    return null;
  }

  // Helper function to convert YouTube URL to embed URL
  const getEmbedUrl = (url) => {
    const videoId = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/);
    return videoId ? `https://www.youtube.com/embed/${videoId[1]}` : url;
  };

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="youtube">
        <div className="youtube-header">
          <h1 className="youtube-header-title">{youtubeSection.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode youtube-header-subtitle"
                : "subTitle youtube-header-subtitle"
            }
          >
            {youtubeSection.subtitle}
          </p>
        </div>
        <div className="youtube-main-div">
          {youtubeSection.videos.map((video, i) => {
            if (!video || !video.url) {
              console.log(
                `Video data for ${youtubeSection.title} is missing`
              );
              return null;
            }
            return (
              <div key={i} className="youtube-video-container">
                <div className="youtube-video-wrapper">
                  <iframe
                    className="youtube-video"
                    src={getEmbedUrl(video.url)}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title={video.title || "YouTube Video"}
                  ></iframe>
                </div>
                <div className="youtube-video-info">
                  <h3 
                    className={
                      isDark
                        ? "dark-mode youtube-video-title"
                        : "youtube-video-title"
                    }
                  >
                    {video.title}
                  </h3>
                  <p 
                    className={
                      isDark
                        ? "dark-mode youtube-video-description"
                        : "youtube-video-description"
                    }
                  >
                    {video.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Fade>
  );
}